export function validateSynergyUnderwritingBands(
  value: unknown,
  allowSignedTargets: boolean,
  errors: string[],
): void {
  if (!isRecord(value)) {
    errors.push('bands must be an object');
    return;
  }
  const validateTarget = allowSignedTargets
    ? validateSignedFiniteNumber
    : validateNonNegativeFiniteNumber;
  const conservative = validateTarget(
    value.conservativeRunRateUsd,
    'bands.conservativeRunRateUsd',
    errors,
  );
  const base = validateTarget(
    value.baseRunRateUsd,
    'bands.baseRunRateUsd',
    errors,
  );
  const stretch = validateTarget(
    value.stretchRunRateUsd,
    'bands.stretchRunRateUsd',
    errors,
  );
  validateNonNegativeFiniteNumber(
    value.oneTimeCostUsd,
    'bands.oneTimeCostUsd',
    errors,
  );
  validateText(value.bandBasis, 'bands.bandBasis', errors);
  if (
    conservative !== null &&
    base !== null &&
    stretch !== null &&
    !(conservative <= base && base <= stretch)
  ) {
    errors.push('bands must satisfy conservative <= base <= stretch');
  }
}

function validateNonNegativeFiniteNumber(
  value: unknown,
  path: string,
  errors: string[],
): number | null {
  const number = validateSignedFiniteNumber(value, path, errors);
  if (number !== null && number < 0) {
    errors.push(`${path} must be a non-negative finite number`);
    return null;
  }
  return number;
}

function validateSignedFiniteNumber(
  value: unknown,
  path: string,
  errors: string[],
): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    errors.push(`${path} must be a finite number`);
    return null;
  }
  return value;
}

function validateText(value: unknown, path: string, errors: string[]): void {
  if (typeof value !== 'string' || value.trim().length === 0) {
    errors.push(`${path} is required`);
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
